import { Component, OnInit } from '@angular/core';
import { ServerService } from '../services/server.service';
import { Router } from '@angular/router';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';

declare var $:any;
import Swal from 'sweetalert2';
declare var iziToast:any;
@Component({
  selector: 'app-allow-whitelist',
  templateUrl: './allow-whitelist.component.html',
  styleUrls: ['./allow-whitelist.component.css']
})
export class AllowWhitelistComponent implements OnInit {

  allowedList;
  deletedList;
  countrylist;
  grouplist;
  ipinformation: FormGroup;
  constructor(public router:Router,private serverService: ServerService) { }

  ngOnInit(): void {
    this.getCountryList();
    this.getGroupList();
    this.getDeletedList();
    this.getAllowedList();


    this.ipinformation = new FormGroup({
      'customername' : new FormControl(localStorage.getItem('cn'),
    Validators.required),
      'ipaddress' : new FormControl(null,[Validators.required,this.customValidator()]),
      'country' : new FormControl(null,Validators.required),
      'tagged_name': new FormControl(null,Validators.required),
     });



  }


  addnewuser(){
    $("#createipmodal").modal('show');
  }


  getAllowedList(){

    let datas:any =new Object();
    let datasend:any = new Object();
    let access_token: any=localStorage.getItem('at');
    let customer_id: any=localStorage.getItem('en');
      
      
   datas.action="allowed_list";
   datas.customer_id = customer_id;
   datas.limit = '50';
   datas.offset = '0';
     
   
    datasend.access_token=access_token;
     datasend.operation="curlDatas";
     datasend.moduleType="dc_ip";
     datasend.api_type="web";
     datasend.element_data = datas;
         this.serverService.sendServer(datasend).subscribe((response: any) => {

          console.log(response);
          // this.allowedList = response.result_data.dcip_list;
          this.allowedList = response.dclist;
      
      }, 
      (error)=>{
          console.log(error);
      });

  }


  getDeletedList(){

    let datas:any =new Object();
    let datasend:any = new Object();
    let access_token: any=localStorage.getItem('at');
    let customer_id: any=localStorage.getItem('en');
      
      
   datas.action="deleted_list";
   datas.customer_id = customer_id;
   datas.limit = '50';
   datas.offset = '0';
     
    
    datasend.access_token=access_token;
     datasend.operation="curlDatas";
     datasend.moduleType="dc_ip";
     datasend.api_type="web";
     datasend.element_data = datas;
         this.serverService.sendServer(datasend).subscribe((response: any) => {
          this.deletedList = response.dclist;
 
      
      }, 
      (error)=>{
          console.log(error);
      });

  }


  deleteTheIP(id_received,server){
    
    let datas:any =new Object();
    let datasend:any = new Object();
    let access_token: any=localStorage.getItem('at');
    let customer_id: any=localStorage.getItem('en');
      
      
   datas.action="delete_dcip";
   datas.customer_id = customer_id;
   datas.id = id_received;     
   datas.country_id = server;     
    
    datasend.access_token=access_token;
     datasend.operation="curlDatas";
     datasend.moduleType="dc_ip";
     datasend.api_type="web";
     datasend.element_data = datas;
         this.serverService.sendServer(datasend).subscribe((response: any) => {

          if(response.status == 'true'){
          iziToast.success({
            message: "IP Address removed successfully",
            position: 'topRight'
        });
            this.getAllowedList();
            this.getDeletedList();

          }else{
            iziToast.error({
              message: "IP Address Deletion Failed",
              position: 'topRight'
          });
          }
      
      }, 
      (error)=>{
          console.log(error);
      });

  }

  getGroupList(){


    let datas:any =new Object();
    let datasend:any = new Object();
    let access_token: any=localStorage.getItem('at');      
      
   datas.action="group_list";  
    
    datasend.access_token=access_token;
     datasend.operation="curlDatas";
     datasend.moduleType="dc_ip";
     datasend.api_type="web";
     datasend.element_data = datas;
         this.serverService.sendServer(datasend).subscribe((response: any) => {

          console.log(response);
          this.grouplist = response.dclist;
      
      }, 
      (error)=>{
          console.log(error);
      });

  }
  
  getCountryList(){

    let datas:any =new Object();
    let datasend:any = new Object();
    let access_token: any=localStorage.getItem('at');      
      
   datas.action="country_list";  
    
    datasend.access_token=access_token;
     datasend.operation="curlDatas";
     datasend.moduleType="dc_ip";
     datasend.api_type="web";
     datasend.element_data = datas;
         this.serverService.sendServer(datasend).subscribe((response: any) => {

          console.log(response);
          this.countrylist = response.dclist;
      
      }, 
      (error)=>{
          console.log(error);
      });

  }

  submitForm(){
    
  if(this.ipinformation.valid){
    Swal.fire('Loading');
    Swal.showLoading();
    let datas:any =new Object();
    let datasend:any = new Object();
    let access_token: any=localStorage.getItem('at');      
    let customer_id: any=localStorage.getItem('en');

    let group_nunber =this.grouplist.filter(word => 
      
        word.country == this.ipinformation.value.country && word.id != '6'
    
      );

     let joins =  group_nunber.map(city => city.id ).join(',');


     let temp;

     if($("#flexSwitchCheckDefault").prop('checked') == true){
      temp = 1;
    }else{
       temp = 0;
     }

      datas.action="add_dcip";  
      datas.customer_id = customer_id;
      datas.customer_name=this.ipinformation.value.customername;  
      datas.short_name=this.ipinformation.value.customername;   
      datas.country=this.ipinformation.value.country;    
      datas.tag_name=this.ipinformation.value.tagged_name;    
      datas.grpname=joins;  
      datas.ip_data_from=this.ipinformation.value.ipaddress;  
      datas.temp=temp;  
    
      datasend.access_token=access_token;
      datasend.operation="curlDatas";
      datasend.moduleType="dc_ip";
      datasend.api_type="web";
      datasend.element_data = datas;


         this.serverService.sendServer(datasend).subscribe((response: any) => {
          Swal.close();
          if(response.status == 'true'){
          console.log(response);

          this.getAllowedList();
          $("#createipmodal").modal('hide');
          this.ipinformation.patchValue({
          'ipaddress' : null,
          'country' :null
          });

        }

      }, 
      (error)=>{
          console.log(error);
      });

  }
}

keyPressAlphaNumeric(event) {

  var inp = String.fromCharCode(event.keyCode);

  if (/[a-zA-Z0-9]/.test(inp)) {
    return true;
  } else {
    event.preventDefault();
    return false;
  }
}


showmodal(){

  //  Swal.fire({
	// 		html:
	// 			'<div class="cube-wrapper"><div class="cube-folding"><span class="leaf1"></span><span class="leaf2"></span><span class="leaf3"></span><span class="leaf4"></span></div><span class="loading" data-name="Loading">Loading</span></div>',
	// 	showCloseButton: false,
	// 		showCancelButton: false,
	// 		showConfirmButton: false,
	// 		focusConfirm: false,
	// 		background: 'transparent'
	// 	});


}

restoredIP(getvalues){

  console.log(getvalues)
    
  Swal.fire('Loading');
  Swal.showLoading();
    let datas:any =new Object();
    let datasend:any = new Object();
    let access_token: any=localStorage.getItem('at');      
    let customer_id: any=localStorage.getItem('en');
 
    let group_nunber =this.grouplist.filter(word => 
      
      word.country == getvalues.countryid && word.id != '6'
  
    );

   let joins =  group_nunber.map(city => city.id ).join(',');

      datas.action="add_dcip";  
      datas.customer_id = btoa(getvalues.customer_id);
      datas.customer_name=getvalues.customer_name;  
      datas.short_name=getvalues.short_name;   
      datas.country=getvalues.countryid;    
      // datas.grpname=getvalues.group_name;  
      datas.grpname=joins;  
      datas.ip_data_from=getvalues.ip_data_from;  
      datas.tag_name=getvalues.tag_name;  
      datas.temp=getvalues.temp;  

      
    
      datasend.access_token=access_token;
      datasend.operation="curlDatas";
      datasend.moduleType="dc_ip";
      datasend.api_type="web";
      datasend.element_data = datas;
       
         this.serverService.sendServer(datasend).subscribe((response: any) => {
          Swal.close();
          if(response.status == 'true'){
          console.log(response);

          this.getAllowedList();
          this.getDeletedList();

        }

      }, 
      (error)=>{
          console.log(error);
      });

}

//  ValidateIPaddress(ipaddress) {
//  if (/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test())
//   {
//     return (true)
//   }
// alert("You have entered an invalid IP address!")
// return (false)
// }


  customValidator() {
  return (control) => {
    const regex = /^(?:[0-9]{1,3}\.){3}[0-9]{1,3}$/;

    if (regex.test(control.value)) {
      return null;
    }

    return { ipError: true };
  };
}


}
